module.exports = __webpack_public_path__ + "218aec7a7a909b8e2299f6e069ab147c.png";